const envs = {
	APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
	COMPANY_NAME: process.env.NEXT_PUBLIC_COMPANY_NAME,
	COMPANY_SUPPORT_EMAIL: process.env.NEXT_PUBLIC_COMPANY_SUPPORT_EMAIL,
	GDPR_SUPPORT_EMAIL: process.env.NEXT_PUBLIC_GDPR_SUPPORT_EMAIL ?? 'gdpr@binary.so',
	BOOK_DEMO_URL: process.env.NEXT_PUBLIC_BOOK_DEMO_URL,
	INTERCOM_APP_ID: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
	COMPANY_DOMAIN: process.env.NEXT_PUBLIC_COMPANY_DOMAIN,
	APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
	APP_TITLE: process.env.NEXT_PUBLIC_APP_TITLE,
	API_ENDPOINT_V1: process.env.NEXT_PUBLIC_API_ENDPOINT_V1,
	MIXPANEL_PROJECT_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN,
	MIXPANEL_ENV: process.env.NEXT_PUBLIC_MIXPANEL_ENV,
	STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
	GOOGLE_PROJECT_NUMBER: process.env.NEXT_PUBLIC_GOOGLE_PROJECT_NUMBER,
	GCAL_DWD_CLIENT_ID: process.env.NEXT_PUBLIC_GCAL_DWD_CLIENT_ID,
};

const missing = Object.entries(envs)
	.filter(([, value]) => !value)
	.map(([key]) => `NEXT_PUBLIC_${key}`);

if (missing.length > 0) {
	throw new Error(`Missing required environment variables:\n  - ${missing.join('\n  - ')}`);
}

export const APP_ENVS = envs as { [K in keyof typeof envs]: string };

/** Canonical absolute origin for building public URLs (no trailing slash). */
export const COMPANY_BASE_URL = (APP_ENVS.COMPANY_DOMAIN ?? '').trim().replace(/\/$/, '');

/** Staging/test environment origin — must stay out of search indexes. */
export const STAGING_URL = 'https://applytest.in';

/** True when the current deployment is the staging environment (noindex everywhere). */
export const IS_STAGING = COMPANY_BASE_URL === STAGING_URL;
